module.exports = __webpack_public_path__ + "img/shandianzhuanfa.e800d5a0.png";